import { LENDER_IDs, ORG_IDS } from "../utils/constants";
import { getUserLenderID } from "../utils/Global";
import { useMemo } from "react";

/**
 * Custom hook to check if the current user corresponds to HFCL
 * @returns {boolean} True if the user is HFCL, false otherwise
 */
export const useIsHFCL = (
  isLender: boolean = true,
  userState?: any
): boolean => {
  return useMemo(() => {
    if (isLender) {
      const lenderID = getUserLenderID();
      return lenderID === LENDER_IDs.HFCL;
    } else {
      const { organizationID = "" } = userState ?? {};
      return organizationID === ORG_IDS.HFCL;
    }
  }, [isLender, userState]);
};
